module.exports = __webpack_public_path__ + "static/img/prize-header.94c55d4f.png";